var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "svgPath",
    d: "M22 12C27.523 12 32 16.478 32 22C32 27.522 27.523 32 22 32C16.477 32 12 27.522 12 22C12 16.478 16.477 12 22 12ZM22 13.667C17.405 13.667 13.667 17.405 13.667 22C13.667 26.595 17.405 30.333 22 30.333C26.595 30.333 30.333 26.595 30.333 22C30.333 17.405 26.595 13.667 22 13.667ZM21.9987 24.5022C22.5502 24.5022 22.9973 24.9494 22.9973 25.5009C22.9973 26.0524 22.5502 26.4996 21.9987 26.4996C21.4471 26.4996 21 26.0524 21 25.5009C21 24.9494 21.4471 24.5022 21.9987 24.5022ZM21.9945 17C22.3742 16.9997 22.6882 17.2816 22.7381 17.6476L22.7451 17.7494L22.7487 22.251C22.749 22.6652 22.4135 23.0013 21.9993 23.0016C21.6196 23.0019 21.3055 22.72 21.2556 22.354L21.2487 22.2522L21.2451 17.7506C21.2447 17.3364 21.5802 17.0003 21.9945 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.d2e237c8d3b8889c792921cd2935b62f.svg";
export { ForwardRef as ReactComponent };